/**
 * @typedef {Object} TestableCommand
 * @property {string=} code
 * @property {string=} eventType
 */

/**
 * @typedef {Object} LogLine
 * @property {string} level
 * @property {string} message
 * @property {string} createdAt
 */

/**
 * @typedef {Object} CommandTestService
 * @property {function(TestableCommand): angular.IPromise<LogLine[]>} post
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {CommandTestService}
 */
function bahabotCommandTestFactory($resource, $q) {
    const CommandTest = $resource('/api/protected/command-test', {
        'id': '@id'
    }, {
        post: { method: 'POST' }
    });

    return {
        post: function (command) {
            return CommandTest.post(command).$promise.then(res => res.data)
        }
    };
}

mod.factory('CommandTestService', ["$resource", bahabotCommandTestFactory]);
